import React, { useState } from 'react';
import { ReactComponent as Logo } from '../assets/logo.svg';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

interface HeaderProps {
  children?: React.ReactNode; // бургер из PrivateLayout
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = useState(false);
  const toggleDrawer = () => setMobileOpen(!mobileOpen);

  const isPublic = ['/', '/login', '/register'].includes(location.pathname);
  const isInCabinet = user && !isPublic;

  // ----------------- Мобильные кнопки -----------------
  const mobileButtons = (
    <List>
      {isInCabinet && (
        <ListItemButton component={RouterLink} to="/" onClick={toggleDrawer} sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}>
          <ListItemText primary="Главная" />
        </ListItemButton>
      )}

      {user ? (
        isPublic ? (
          <ListItemButton component={RouterLink} to="/accounts" onClick={toggleDrawer} sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}>
            <ListItemText primary="Личный кабинет" />
          </ListItemButton>
        ) : (
          <ListItemButton
            onClick={() => {
              logout();
              toggleDrawer();
            }}
            sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
          >
            <ListItemText primary="Выйти" />
          </ListItemButton>
        )
      ) : (
        <>
          <ListItemButton component={RouterLink} to="/login" onClick={toggleDrawer} sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}>
            <ListItemText primary="Войти" />
          </ListItemButton>
          <ListItemButton component={RouterLink} to="/register" onClick={toggleDrawer} sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}>
            <ListItemText primary="Регистрация" />
          </ListItemButton>
        </>
      )}
    </List>
  );

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: '#1E3A8A', boxShadow: 1 }}>
        <Toolbar>
          {/* ----------------- БУРГЕР НА МОБИЛКЕ ----------------- */}
          {/* показываем только если нет children */}
          {!children && (
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
              <IconButton color="inherit" onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>
            </Box>
          )}

          {/* ----------------- ЛОГОТИП ----------------- */}
            <Box
                component={RouterLink}
                to={user ? '/accounts' : '/'}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    color: 'white',
                    flexGrow: 1,
                    gap: 1,
                    ml: {xs: 1, md: 0},
                }}
            >
                {/* SVG логотип */}
                 <Logo
    style={{
      height: 32,
      width: 'auto',

    }}
  />

                {/* Текст */}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                    }}
                >
                    Typhon
                </Typography>
            </Box>

          {/* ----------------- КНОПКИ ДЕСКТОП ----------------- */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
            {isInCabinet && (
              <Button
                color="inherit"
                component={RouterLink}
                to="/"
                startIcon={<HomeIcon />}
                sx={{ textTransform: 'none', fontWeight: 500, '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
              >
                Главная
              </Button>
            )}

            {user ? (
              isPublic ? (
                <Button color="inherit" component={RouterLink} to="/accounts">
                  Личный кабинет
                </Button>
              ) : (
                <Button color="inherit" onClick={logout}>
                  Выйти
                </Button>
              )
            ) : (
              <>
                <Button color="inherit" component={RouterLink} to="/login">
                  Войти
                </Button>
                <Button color="inherit" component={RouterLink} to="/register">
                  Регистрация
                </Button>
              </>
            )}
          </Box>

          {/* ----------------- CHILDREN ----------------- */}
          {children}
        </Toolbar>
      </AppBar>

      {/* ----------------- DRAWER МОБИЛКА ----------------- */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={toggleDrawer}
        sx={{
          '& .MuiDrawer-paper': { bgcolor: '#1E3A8A', color: 'white' },
        }}
      >
        <Box sx={{ width: 250 }}>
          {/* кнопка закрытия */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
            <IconButton onClick={toggleDrawer} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {mobileButtons}
        </Box>
      </Drawer>
    </>
  );
};

export default Header;